module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('h1', {
    staticClass: "cn",
    attrs: {
      "id": "_idParaDest-6"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  }), _vm._v("Chapter Two")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("Mary’s childhood home was a modest brick ranch in a Rotorua suburb. Alexa parked on the street and, transfixed by the aroma of rosemary and garlic, walked down the driveway carrying a twelve-pack of beer and a bouquet of white roses.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("A dark-haired man in khakis and a polo shirt was standing in the front garden at a barbecue. “Alexa Glock?”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("She nodded. “Terrance Horomia?”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Terrance had Mary’s eyes: topaz and voluminous. He pressed his nose and forehead against Alexa’s in the traditional Maori greeting. “You had a safe journey from Auckland, I hope,” he said. A tattoo of intricate spirals spilled from his short sleeves and ended at the wrist.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Alexa flushed, stepped back. “Yes, thank you. I am sorry for your loss. Mary was planning to bring me to Rotorua soon.”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Terrance grunted. “She barely ever came back. Busy running from her roots.”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Alexa didn’t know what to say. “Where shall I put these?” She held up her offerings.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“Leave the brew here. I’ll add it to the chiller. Go meet my wife and children. My mother and cousin are here too.” He turned abruptly toward the rack of sizzling meat.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“Lamb?”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("A nod as he brushed the crunchy skin with more oil and herbs.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("The foyer opened to a den straight ahead, where she could hear TV garble and giggles, and a kitchen to the right. A plump, gray-haired woman was stirring a pot; a younger woman chopped mint.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“"), _c('em', {
    staticClass: "i"
  }, [_vm._v("Nau mai")]), _vm._v(", child,” said the stirrer. “I’m Lorette Horomia, Mary’s mother. It’s good to meet her American friend.” She let go of the wooden spoon and opened her arms, cloaking Alexa in an embrace.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“I am sorry for your loss,” Alexa said into her soft shoulder and longed to sink deeper. Here this mother was, providing comfort when she should be receiving it. What would the loss of a child be like? Alexa couldn’t fathom it, but she knew the loss of a mother.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Dressed in black leggings and a red-and-black swirly tunic, the other woman turned and offered her hand. “We will forge a new path. I am Mary’s cousin, Jeannie.”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("No smile.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“What can I do to help? And where shall I put these flowers?” ")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("A third woman, spilling out of a tight aqua sundress, walked in. “"), _c('em', {
    staticClass: "i"
  }, [_vm._v("Kia ora")]), _vm._v(".” She introduced herself as Ellie, Terrance’s wife. Her open smile revealed overlapping front teeth. “Come meet our children, Mary’s niece and nephew.”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Alexa returned the smile and followed her to the den.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Two dark heads turned from the flat screen when they walked in, Alexa still holding the roses. “This is Kala,” said Ellie. “Our oldest.”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“I’m almost nine,” said Kala.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“I’m Kyle and I’m seven,” her brother said. ")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“No, you’re not!” said Kala. “You’re six.”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“Well, this is Alexa, Aunt Mary’s friend from America,” their mother explained.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("The children eyed Alexa.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“I’m sorry about your aunt. There were pictures of you two on her desk.” She hoped that was okay to say. Children were as unpredictable as dogs.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“I saw Auntie Mare dead in her coffin. She didn’t open her eyes,” Kyle said. “Are you someone’s mum?”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“No. I…”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“Alexa is going to have tea with us,” Ellie interrupted.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“Why do you have flowers?” Kala asked.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“They’re for your family. Do you want to help me arrange them in a vase?”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“Okay,” Kala said, jumping up. She skipped behind Alexa back to the kitchen.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("The lamb was unveiled in the center of the crowded table. Dishes of roasted spring potatoes, mint sauce, steamed carrots, and green beans were passed around. Jeannie thawed a tad when Alexa complimented her on the mint sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“Did my sister ever mention moving back here?” Terrance asked, setting down his fork.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“She talked about all of you. And about Rotorua. She had invited me for the holidays.” A stab of panic. If she stayed in New Zealand, she’d be alone at Christmas.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“You can still come,” said Kyle. “We’ll have barbie and pavlova.”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Barbie? Pavlova?")]), _vm._v(" Everyone laughed at Alexa’s expression, and Ellie explained the Kiwi tradition of a Christmas day cookout and the whipped cream meringue dessert.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“Do you have snakes and lions and bears in ’Merica?” Kala asked.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“We have lots of snakes and a few bears, but luckily no lions,” Alexa answered.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“You talk funny. We’re having hokey pokey for dessert,” Kyle said.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“Hocus-pocus? Is that a magic trick?”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“It’s ice cream!” he screamed.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“Kyle, it’s rude to say someone talks funny,” his mom said. “You could say, ‘Your accent is different.’”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“Your accent is different,” Kyle said. Everyone laughed again. ")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Jeannie asked Alexa what brought her to New Zealand.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“I just finished a teaching fellowship in the forensics department at Auckland University. That’s where I met Mary. Her lab was next door. I specialize in odontology…teeth.”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Kyle stuck his tongue through the gap in his front teeth, and Alexa laughed. She didn’t usually like children, but this one was growing on her. “I work with old teeth, not new ones like yours.”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“Like Nana’s?” Kyle asked.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Like dug-up skeletons and plane-crash victims")]), _vm._v(". “Even older.”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“Will you head back to the States now?” Jeannie asked.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“I might stay longer if I can find another job. My work visa can be extended indefinitely if I work in a high-needs field. I stopped by the Rotorua Police Department this afternoon. To see if they need help with the death at the mud pots.”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“My class went to the Waiariki mud pots,” piped Kala. “They’re scary. The mud is alive. Jason said Maori used to cook people in them and eat them. And Samara saw bones poking out.”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“Is that true, Mum?” Kyle asked in a worried tone.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("A bang came from the end of the table. “That’s enough, Kala.” Terrance’s voice drowned Ellie’s response. “Do not desecrate your ancestors.” Uncomfortable silence followed. Terrance, frowning, said no more, and his clan jumped up to clear the table.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78996973","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MoltenMudMurder-6.vue
// module id = 75
// module chunks = 0